"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_INPUT_ORDER = exports.InputOrderSchema = void 0;
exports.compareInputOrder = compareInputOrder;
exports.hasOnlyRelatedInputTables = hasOnlyRelatedInputTables;
exports.hasSelfRelatedInputTable = hasSelfRelatedInputTable;
const zod_1 = require("zod");
/**
 * The order a run takes the rows of its source table in: by the time a row
 * was created, oldest or newest first. A union, so an order by a column can
 * follow without a new contract.
 */
exports.InputOrderSchema = zod_1.z.discriminatedUnion('by', [
    zod_1.z
        .object({ by: zod_1.z.literal('created'), direction: zod_1.z.enum(['asc', 'desc']) })
        .strict(),
]);
/** The order of a new automation: oldest rows first. */
exports.DEFAULT_INPUT_ORDER = {
    by: 'created',
    direction: 'asc',
};
/**
 * The order of two rows for a run of an automation, as the server claims
 * them (`ORDER BY row_created_at <direction>, row_id <direction>`): by the
 * time they were created, a tie by row id, both in the direction of `order`.
 */
function compareInputOrder(order, a, b) {
    const ascending = a.createdAt - b.createdAt ||
        (a.rowId < b.rowId ? -1 : a.rowId > b.rowId ? 1 : 0);
    return order.direction === 'desc' ? -ascending : ascending;
}
/** Additional automation input tables must be bound to a relation on the main table. */
function hasOnlyRelatedInputTables(tables) {
    return (tables ?? []).every(table => table.role !== 'secondary' || !!table.linkedVia);
}
/**
 * A related input table must be another table than the source table: a
 * relation from a table to itself would hand a run rows that the same
 * automation also processes, marks and writes as source rows.
 */
function hasSelfRelatedInputTable(sourceTableId, tables) {
    if (!sourceTableId)
        return false;
    return (tables ?? []).some(table => table.role === 'secondary' && table.tableId === sourceTableId);
}
//# sourceMappingURL=input.js.map